import React,{Component} from 'react';
import {createMarkup} from './Factory'

class NewsItem extends Component {
	
	render(){				
		const { title,designation,email,telephone } = this.props;
		let $telephone = '';
		if(telephone){
			$telephone = <a href={`tel:+${telephone}`}>T +{telephone}</a>
		}
		return(
				<div className="team-item clearfix">
					<div className="col name" dangerouslySetInnerHTML={createMarkup(title.rendered)}></div>
					<div className="col role" dangerouslySetInnerHTML={createMarkup(designation)}></div>
					<div className="col contact">
						{$telephone} <br/>
						<a href={`mailto:${email}`}>{email}</a>
					</div>
				</div>
		)
	}
}
export default NewsItem;




// WEBPACK FOOTER //
// ./src/components/TeamItem.js